var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "service-wrapper" }, [
    _c("img", { attrs: { src: "/static/images/2500/2500@2x.png", alt: "" } }),
    _vm._v(" "),
    _c("h5", [_vm._v("2500在线客服")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "即将上线在线客服, 让沟通交流更方便, 7*16小时保障蔚来员工日常办公需求。"
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "button", on: { click: _vm.order_func } }, [
      _vm._v("对功能的心愿戳这里")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-a4606e7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-a4606e7a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/2500/service.vue
// module id = null
// module chunks = 